import api from "../index";

const authentication = {
  getAuthentication: async (hash) =>
    await api.get(`/sso/authenticated/${hash}`),
  revalidateToken: async (hash) => await api.get(`/sso/revalidate/${hash}`),
};

export default authentication;
